class PkInfiniteScroll extends HTMLElement {
  constructor() {
    super();

    this.context = this.dataset.context || 'collection';
    this.contextConfig = this.getContextConfig(this.context);

    this.boundClickHandler = this.onClickHandler.bind(this);
    this.addEventListener('click', this.boundClickHandler);

    if (this.dataset.trigger === 'infinite') {
      this.intersectionObserver = new IntersectionObserver(this.handleIntersection.bind(this), {
        rootMargin: '0px 0px 200px 0px',
      });
      this.intersectionObserver.observe(this);
    }
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.boundClickHandler);

    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      this.intersectionObserver = null;
    }
  }

  getContextConfig(context) {
    const contexts = {
      collection: {
        wrapperSelector: '[id^="pk-collection-"]',
        listSelector: '[id^="product-list-"]',        
        itemSelector: ".product-card",     
        paginationSelector: '[id^="pk-pagination-"]'
      },
      blog: {
        wrapperSelector: '[id^="pk-blog-"]',
        listSelector: '[id^="blog-post-list-"]',      
        listSelector: ".blog-post-card",        
        paginationSelector: '[id^="pk-pagination-"]'
      }
    };

    return contexts[context] || contexts.collection;
  }

  onClickHandler() {
    if (
      this.classList.contains('pk-infinite-scroll--loading') ||
      this.classList.contains('pk-infinite-scroll--disabled')
    ) return;

    this.classList.add('pk-infinite-scroll--loading', 'pk-infinite-scroll--disabled');

    const sections = this.getSections();
    sections.forEach(() => {
      const url = this.dataset.url;
      this.renderSectionFromFetch(url);
    });
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    this.onClickHandler();
  }

  getSections() {
    const listElement = document.querySelector(this.contextConfig.listSelector);

    return listElement
      ? [{ section: listElement.dataset.id }]
      : [];
  }

  renderSectionFromFetch(url) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        this.renderPagination(responseText);
        this.renderListItems(responseText);
      })
      .catch((e) => {
        console.error(e);
      });
  }

  renderPagination(html) {
    const wrapper = document.querySelector(this.contextConfig.wrapperSelector);
    const pagination = wrapper?.querySelector(this.contextConfig.paginationSelector);

    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const newWrapper = parsed.querySelector(this.contextConfig.wrapperSelector);
    const newPagination = newWrapper?.querySelector(this.contextConfig.paginationSelector);

    if (pagination && newPagination) {
      pagination.innerHTML = newPagination.innerHTML;
    } else if (pagination) {
      pagination.remove();
    }
  }

  renderListItems(html) {
    const listItems = document.querySelector(this.contextConfig.listSelector);
    const newListItems = new DOMParser().parseFromString(html, 'text/html').querySelector(this.contextConfig.listSelector);

    if (listItems && newListItems) {
      listItems.insertAdjacentHTML('beforeend', newListItems.innerHTML);
    }

    if (this.dataset.trigger == 'click') {
      this.updateCountItems();
    }
  }

  updateCountItems() {
    const listSelector = document.querySelector(this.contextConfig.listSelector);
    const countItems = document.querySelector('[id^="pk-pagination-count-items-"]');
    const progressBar = document.querySelector('[id^="pk-pagination-progress-bar-"]');
    const total = parseInt(this.dataset.total, 10);

    if (listSelector && countItems && progressBar && total) {
      const itemsLength = Array.from(listSelector.querySelectorAll(this.contextConfig.itemSelector)).length;
      countItems.textContent = itemsLength;

      const percent = Math.min((itemsLength / total) * 100, 100);
      progressBar.style.width = `${percent}%`;
    }
  }
}

customElements.define('pk-infinite-scroll', PkInfiniteScroll);
